import { DataSortableColumn } from "@/components/ui/table-final-saviour/Table/columns/data-sortable.table-column";
import { DataColumn } from "@/components/ui/table-final-saviour/Table/columns/data.table-column";
import { Column, Row } from "@/components/ui/table-final-saviour/Table/table.types";

export const isDataColumn = <T extends Row>(
    column: Column<T, any, any>,
): column is DataColumn<T> | DataSortableColumn<T> => {
    return column._type === "data" || column._type === "data_sortable";
};
